<button mat-raised-button color="primary" (click)="fixImages()" *ngIf="!isFixed">Fix Images</button>